import { render } from "./AccesosPlataforma.vue?vue&type=template&id=587e9b4c&scoped=true"
import script from "./AccesosPlataforma.vue?vue&type=script&lang=js"
export * from "./AccesosPlataforma.vue?vue&type=script&lang=js"

import "./AccesosPlataforma.vue?vue&type=style&index=0&id=587e9b4c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587e9b4c"]])

export default __exports__